export enum Enum_Geometry_Types {
    POINT = "Point",
    LINESTRING = "LineString",
    POLYGON = "Polygon",
}

export enum Enum_Action_Type {
    create = "create",
    update = "update",
}

export enum Enum_Entity {
    ELEMENT = "element",
    USER = "user",
    MAP = "map",
    CATEGORY = "category",
}
